import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class ManualAdjustmentRuleAddDialogService {
  [x: string]: any;
  apiUrl = this.environment.apiUrl;
  Bussinessgridapi = this.environment.BussinessgridapiUrl;
  BussinessDropdownApi = this.environment.BusinesssearchdropdownapiUrl;
  // cmpltPrtApi = environment.BusinessManAdjstapiUrl;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  ruleType = '/getRuleTypeBpMar/{proxy+}'
  partDesc = '/getPartDesc/{proxy+}';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }


  //rule type
  getRuleTypeBpMar(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.BussinessDropdownApi + this.ruleType + '?page=' + 'add'+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  //getAddVersionNameBpMar
  getAddVersionNameBpMar(ruletypid): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BussinessgridapiUrl + '/getAddVersionNameBpMar/{proxy+}'+'?man_adj_rule_def='+ruletypid +'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }


  //getAddNamcBpMar
  getAddNamcBpMar(versionName, repBomVerId, fromDate, toDate): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL;
    if (versionName != 'production') {
      API_URL = this.environment.BussinessgridapiUrl + '/getAddNamcBpMar/{proxy+}' + '?repBomVerId=' + repBomVerId + '&versionName=' + versionName+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    }
    else {
      API_URL = this.environment.BussinessgridapiUrl + '/getAddNamcBpMar/{proxy+}' + '?fromDate=' + fromDate + '&toDate=' + toDate + '&versionName=' + versionName+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    }
    return this.http.get(API_URL,httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddFamilyMar
  getAddFamilyMar(repBomVerId, namcId, fromDate, toDate): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BussinessgridapiUrl + '/getAddFamilyMar/{proxy+}'
      + '?repBomVerId=' + repBomVerId + '&namcId=' + namcId + '&fromDate=' + fromDate + '&toDate=' + toDate+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddKatashikiMar
  getAddKatashikiMar(repBomVerId, namcId, famCd): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BussinessgridapiUrl + '/getAddKatashikiMar/{proxy+}'
      + '?repBomVerId=' + repBomVerId + '&namcId=' + namcId + '&famCd=' + famCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  ///getAddGrpiMar
  getAddGrpiMar(namcId, famCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Master_ActionInsertApiUrl + '/getAddGrpiMar/{proxy+}'
      + '?namcId=' + namcId + '&famCd=' + famCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  ///getDestMar
  getDestData(namcId, famCd, katashikiCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.MastersearchdropdownapiUrl + '/getDestByCust/{proxy+}'
      + '?namcId=' + '' + '&famCd=' + '' + '&katashikiCd=' + ''+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddNetSpecMar
  getAddNetSpecMar(namcId, famCd, baseOptnTypCd, repBomVerId): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Master_ActionInsertApiUrl + '/getAddNetSpecMar/{proxy+}'
      + '?namcId=' + namcId + '&famCd=' + famCd + '&baseOptnTypCd=' + baseOptnTypCd + '&repBomVerId=' + repBomVerId+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddPartNoMar
  getAddPartNoMar(namcId, famCd, grpiCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL =this.environment.Master_ActionInsertApiUrl + '/getAddPartNoMar/{proxy+}'
      + '?namcId=' + namcId + '&famCd=' + famCd + '&grpiCd=' + grpiCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddChildPartNoMar
  getAddChildPartNoMar(namcId, famCd, grpiCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Master_ActionInsertApiUrl + '/getAddChildPartNoMar/{proxy+}'
      + '?namcId=' + namcId + '&famCd=' + famCd + '&grpiCd=' + grpiCd +'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddActCurCodeBpMar
  getAddActCurCodeBpMar(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BussinessgridapiUrl + '/getAddActCurCodeBpMar/{proxy+}'+'?screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //getAddCompletePartRoutingMar
  getAddCompletePartRoutingMar(namcId): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Master_ActionInsertApiUrl + '/getAddCmpltPrtRntngMar/{proxy+}' + '?namcId=' + namcId+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //partDesc
  getPartDesc(part): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let partParams = new HttpParams().set("partNo", part);
    let API_URL = this.environment.MastersearchdropdownapiUrl + this.partDesc + '?partNo=' + part+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  /////////insert or add function////////////////////////////
  //addManAdjRule
  getUnitStdPrcAmt(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/getUnitStdPrcAmt/{proxy+}'
    return this.http.post(API_URL, body,httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  chkValParntPartNm(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl+ '/chkValParntPartNm/{proxy+}' + '?parpart' + body.parpart+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  chkValPartNo(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/chkValPartNo/{proxy+}'
    return this.http.post(API_URL, body,httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  chkCarFmFlg(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/chkCarFmFlg/{proxy+}' + '?famCd=' + body.famCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  versionValChk(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/versionValChk/{proxy+}' + '?repBomVerId=' + body.repBomVerId+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }
  //addManAdjRule
  getChildPartNoManAdjAddExclude(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/getChildPartNoManAdjAddExclude/{proxy+}' + "?famCd=" + body.famCd +
      "&namcLglEntityId=" + body.namcLglEntityId +
      "&grpiCd=" + body.grpiCd +
      '&childPartNo=' + body.childPartNo+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  getChildPartNoManAdjAdd(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/getChildPartNoManAdjAdd/{proxy+}' + "?famCd=" + body.famCd +
    "&namcLglEntityId=" + body.namcLglEntityId +
    "&grpiCd=" + body.grpiCd +
    '&childPartNo=' + body.childPartNo+'&screenNo=NBPC_10122'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  chkGrpiCd(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/chkGrpiCd/{proxy+}'
    return this.http.post(API_URL, body,httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  checkIfMarRecordExist(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/checkIfMarRecordExist/{proxy+}'
    return this.http.post(API_URL, body,httpOptions)
      .pipe(catchError(this.error))
  }

  //addManAdjRule
  addManualAdjustmentRule(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinessActionRestapiUrl + '/addManualAdjustmentRule/{proxy+}'
    return this.http.post(API_URL, body,httpOptions)
      .pipe(catchError(this.error))
  }


  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}

